import clsx from 'clsx';
import { RefCallback } from 'react';
import styles from './KgInsightSection.module.scss';

export type KgInsightSectionProps = {
  title?: string;
  subtitle?: string;
  cardsClassName?: string;
  ref?: RefCallback<HTMLElement>;
  children: React.ReactNode;
};

export const KgInsightSection = ({
  title,
  subtitle,
  children,
  cardsClassName,
  ref,
}: KgInsightSectionProps) => (
  <section ref={ref} className={styles.root}>
    {(title || subtitle) && (
      <div className={styles.header}>
        {title && <p className={styles.title}>{title}</p>}
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
    )}
    <div className={clsx(styles.cards, cardsClassName)}>{children}</div>
  </section>
);
